export default __webpack_public_path__ + "static/media/buttonDanceInActive.f46dac7e.svg";